import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { BulkSelectionControl } from "@design-system/BulkSelectionControl/BulkSelectionControl";
import commandIslandStyles from "@design-system/CommandIsland/CommandIslandVariants.module.scss";
import { HStack } from "@design-system/HStack/HStack";

interface Props {
    /** Total selected applicable entities across all filters (drives apply). */
    selectedCount: number;
    onUnselectAll: () => void;
    onContinue: () => void;
}

export const ApplyCoaTemplateSelectEntitiesFooter = ({
    selectedCount,
    onUnselectAll,
    onContinue,
}: Props) => (
    <CommandIsland
        sticky
        alignEnd
        className={commandIslandStyles.bulkActionsStickyFooter}
    >
        <HStack gap={8} align="center" className="mr-auto">
            {selectedCount > 0 && (
                <BulkSelectionControl
                    selectedCount={selectedCount}
                    onClearSelection={onUnselectAll}
                    size="md"
                />
            )}
        </HStack>
        <ButtonWithLoader
            variant="primary"
            size="md"
            type="button"
            loading={false}
            onClick={onContinue}
            disabled={selectedCount === 0}
            hotKey="mod+enter"
            hotKeyOptions={{
                description: "Preview selection",
                preventDefault: true,
            }}
            hotKeyDisplayPosition="inline"
        >
            Preview
        </ButtonWithLoader>
    </CommandIsland>
);
